import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-joshpreet',
  templateUrl: './joshpreet.component.html',
  styleUrls: ['./joshpreet.component.scss']
})
export class JoshpreetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getJoshan();
  }

}
